
import { useCallback, useEffect, useMemo, useState } from "react";
import { Button } from "@/components/ui/button";
import { BeaconsTypes, BeaconsTypesColumns } from "@/pages/beaconTypes/BeaconsTypesColumns";
import Spinner from "../spinnner/Spinner";
import AddBeaconTypeDrawer from "./AddBeaconTypeDrawer";
import UpdateBeaconTypeDrawer from "./UpdateBeaconTypeDrawer";
import useAuth from "@/hooks/useAuth";
import { jwtDecode } from "jwt-decode"
import { BeaconTypesDataTables } from "./BeaconTypeDataTables";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import { errorNotification, successNotification } from "@/utils/Notification";


export default function BeaconsTypesFn() {
    const [data, setData] = useState<BeaconsTypes[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [showAddBeaconTypeDrawer, setShowAddBeaconTypeDrawer] = useState(false)
    const [showUpdateBeaconTypeDrawer, setShowUpdateBeaconTypeDrawer] = useState(false)
    const [beaconsTypesData, setBeaconsTypesData] = useState<BeaconsTypes | undefined>(undefined)
    const { auth } = useAuth()
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()

    const getBeaconsTypes = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconTypes', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: BeaconsTypes[]) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false
            controller.abort()
        };
    };


    useEffect(() => {
        getBeaconsTypes()
    }, []);

    const deteleBeaconTypeById = (beconTypeId: any) => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.delete(`/api/v1/beaconTypes/${beconTypeId}`, {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    successNotification(
                        "Beacon Type successfully deleted",
                        `Beacon Type with id ${beconTypeId} was deleted`,
                        'topRight'
                    );

                }
                getBeaconsTypes()
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    const editFunctionCall = (beaconsTypes: BeaconsTypes) => {
        setBeaconsTypesData(beaconsTypes)
        setShowUpdateBeaconTypeDrawer(!showUpdateBeaconTypeDrawer)
    }

    const deleteFunctionCall = async (beaconsTypes: BeaconsTypes) => {
        deteleBeaconTypeById(beaconsTypes.id)
    }


    const onDelete = useCallback(
        (beaconsTypes: BeaconsTypes) => deleteFunctionCall(beaconsTypes),
        []
    )

    const onEdit = useCallback(
        (beaconsTypes: BeaconsTypes) => editFunctionCall(beaconsTypes),
        []
    )


    const beaconsTypesColumnsData = useMemo(() => BeaconsTypesColumns({ onEdit, onDelete, roles }), [])


    if (loading) {
        return <Spinner />
    }

    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>

            {roles.includes('beacon-types-create') && (
                <Button
                    variant='default'
                    className="flex items-center justify-end"
                    onClick={() => setShowAddBeaconTypeDrawer(!showAddBeaconTypeDrawer)}
                >
                    create Beacon Types
                </Button>
            )}
            <BeaconTypesDataTables columns={beaconsTypesColumnsData} data={data} filterNameColumn="uuid" />

            {roles.includes('beacon-types-create') && (
                <AddBeaconTypeDrawer
                    showAddBeaconTypeDrawer={showAddBeaconTypeDrawer}
                    setShowAddBeaconTypeDrawer={setShowAddBeaconTypeDrawer}
                    getBeaconsTypes={getBeaconsTypes}
                />
            )}
            {beaconsTypesData && roles.includes('beacon-types-edit') && (
                <UpdateBeaconTypeDrawer
                    showUpdateBeaconTypeDrawer={showUpdateBeaconTypeDrawer}
                    setShowUpdateBeaconTypeDrawer={setShowUpdateBeaconTypeDrawer}
                    BeaconsTypes={beaconsTypesData}
                    getBeaconsTypes={getBeaconsTypes}
                    setBeaconsTypesData={setBeaconsTypesData}
                />
            )}
        </main>
    )
}